import { Check } from "lucide-react";
import Crewmate from "../../components/Crewmate";

// ── Truth or Dare Player Controller ──────────────────────────────────────────
// Props:
//   isMyTurn  : bool
//   type      : "truth" | "dare" | null
//   content   : string | null
//   completed : bool
//   skipped   : bool
//   onChoice  : (choice: "truth" | "dare") => void
//   onComplete: () => void
//   onSkip    : () => void

export default function TruthDarePlayer({ isMyTurn, type, content, completed, skipped, onChoice, onComplete, onSkip }) {
  const isDone = completed || skipped;

  // Waiting for your turn
  if (!isMyTurn) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center animate-slide-up">
          <div className="flex justify-center mb-4">
            <Crewmate color="#ff8c00" size={80} animate="wiggle" />
          </div>
          <h2 className="font-display text-xl text-white mb-2">Ожидай своей очереди</h2>
          <p className="font-heading text-[#aaa]">Смотри на главный экран!</p>
        </div>
      </div>
    );
  }

  // Choose truth or dare
  if (!type) {
    return (
      <div className="flex-1 flex flex-col animate-slide-up">
        <div className="text-center mb-6">
          <div className="flex justify-center mb-3">
            <Crewmate color="#ff8c00" size={80} animate="wiggle" />
          </div>
          <h2 className="font-display text-2xl text-white">Твой ход!</h2>
          <p className="font-heading text-[#aaa]">Выбери:</p>
        </div>
        <div className="flex-1 flex flex-col gap-4">
          <button
            onClick={() => onChoice("truth")}
            data-testid="choice-truth"
            className="btn-cartoon btn-secondary"
            style={{ flex: 1, fontSize:"var(--fs-2xl)", padding: "1.75rem" }}
          >
            🤔 ПРАВДА
          </button>
          <button
            onClick={() => onChoice("dare")}
            data-testid="choice-dare"
            className="btn-cartoon btn-orange"
            style={{ flex: 1, fontSize:"var(--fs-2xl)", padding: "1.75rem" }}
          >
            🔥 ДЕЙСТВИЕ
          </button>
        </div>
      </div>
    );
  }

  // Show task
  return (
    <div className="flex-1 flex flex-col animate-slide-up">
      {/* Type badge */}
      <div className="text-center mb-4">
        <div className="inline-block px-6 py-2 rounded-full font-bold text-lg" style={{
          background: type === "truth" ? "#00f5ff" : "#ff8c00",
          border: "2.5px solid #000",
          boxShadow: "3px 3px 0 #000",
          color: type === "truth" ? "#000" : "#fff",
          fontFamily: "'Fredoka One', sans-serif",
        }}>
          {type === "truth" ? "🤔 ПРАВДА" : "🔥 ДЕЙСТВИЕ"}
        </div>
      </div>

      {/* Task card */}
      <div className="flex-1 flex items-center justify-center">
        <div className="card-cartoon p-6 text-center">
          <h2 className="font-heading text-xl text-white leading-tight">{content}</h2>
        </div>
      </div>

      {/* Buttons or result */}
      {isDone ? (
        <div className="text-center mt-4 animate-bounce-in">
          {completed ? (
            <>
              <div className="text-5xl mb-2">✅</div>
              <p className="font-display text-xl" style={{ color: "#3dffa0" }}>+50 очков!</p>
            </>
          ) : (
            <>
              <div className="text-5xl mb-2">😬</div>
              <p className="font-display text-xl" style={{ color: "#ff3355" }}>−25 очков</p>
            </>
          )}
        </div>
      ) : (
        <div className="flex gap-3 mt-4">
          <button
            onClick={onComplete}
            data-testid="complete-task-btn"
            className="btn-cartoon btn-success flex-1 py-4 text-lg"
          >
            <Check className="w-5 h-5 inline mr-2" />
            Выполнено!
          </button>
          <button
            onClick={onSkip}
            data-testid="skip-task-btn"
            className="btn-cartoon btn-error py-4 px-4"
            title="Отказаться (−25 очков)"
          >
            <span style={{ fontSize:"var(--fs-xl)" }}>✗</span>
            <span className="text-sm ml-1 font-display">−25</span>
          </button>
        </div>
      )}
    </div>
  );
}
